(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["omtilo-region-selector"] && !Shopify.designMode) return;
  try {
    class OmtiloRegionSelector extends HTMLElement {
    /* NOTE: never name these fields `popover`/`hidden`/`title` — those are
       native HTMLElement properties; assigning an element to `popover`
       coerces to a string AND activates the browser Popover API (UA white
       background + 3px border) on the host element. */
    connectedCallback() {
      this.toggleButton = this.querySelector('[data-region-toggle]');
      this.panel = this.querySelector('[data-region-pop]');
      if (!this.toggleButton || !this.panel) return;
      this.toggleButton.addEventListener('click', () => this.togglePanel());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) {
          this.closePanel();
          this.toggleButton.focus();
        }
      });
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closePanel();
      });
    }

    togglePanel() {
      this.panel.hidden ? this.openPanel() : this.closePanel();
    }

    openPanel() {
      document.querySelectorAll('omtilo-region-selector').forEach((selector) => {
        if (selector !== this && typeof selector.closePanel === 'function') selector.closePanel();
      });
      this.panel.hidden = false;
      this.toggleButton.setAttribute('aria-expanded', 'true');
    }

    closePanel() {
      if (!this.panel || this.panel.hidden) return;
      this.panel.hidden = true;
      this.toggleButton.setAttribute('aria-expanded', 'false');
    }
  }

  if (!customElements.get('omtilo-region-selector')) {
    customElements.define('omtilo-region-selector', OmtiloRegionSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
